import { Button, Input } from '@nextui-org/react';
import { IconPlus, IconX } from '@tabler/icons-react';
import { NumericFormat } from 'react-number-format';
import Render from '../../../../components/render';
import { useScale } from '../../../../hooks/use-scale';

const TabScale = () => {
  const { add, data, isLoading, onChange, remove, submit } = useScale();

  return (
    <div className="bg-white p-4 rounded-md shadow-md mt-8 w-full max-w-2xl">
      <p className="font-semibold text-lg mb-0">Configuración de escalas calificaciones numéricas</p>
      <p className="text-gray text-sm">Agregue rango de calificación y descripción (Ejemplo: Letra A; Calificación 18-20; Descripción: Excelente)</p>
      <p className="text-red text-sm">Nota importante: No modificar la escala una vez establecida. Esto podría ocasionar errores en el cálculo de las calificaciones registradas.</p>

      <div className="flex justify-between items-center my-6">
        <p className="font-semibold">Rango de Calificación</p>
        <Button
          className="pl-2 bg-secondary text-white font-semibold text-sm"
          radius="sm"
          size="sm"
          onPress={add}
          startContent={<IconPlus size={18} />}
        >
          Añadir
        </Button>
      </div>

      {data.map((item, index) => (
        <div key={index} className="mb-4 flex items-end">
          <Input
            label="Letra"
            labelPlacement="outside"
            placeholder={item._letter}
            variant="bordered"
            radius="sm"
            className="flex-1 mr-4"
            value={item.letter}
            onValueChange={v => onChange(v, 'letter', index)}
          />
          <NumericFormat
            displayType="input"
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            allowNegative={false}
            value={item.from}
            onValueChange={(v) => onChange(v.value, 'from', index)}
            customInput={Input}
            // A partir de acá se establecen las props del input personalizado (Input)
            label="Desde"
            labelPlacement="outside"
            placeholder={item._from}
            variant="bordered"
            radius="sm"
            className="flex-1 mr-4"
          />
          <NumericFormat
            displayType="input"
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            allowNegative={false}
            value={item.to}
            onValueChange={(v) => onChange(v.value, 'to', index)}
            customInput={Input}
            // A partir de acá se establecen las props del input personalizado (Input)
            label="Hasta"
            labelPlacement="outside"
            placeholder={item._to}
            variant="bordered"
            radius="sm"
            className="flex-1 mr-4"
          />
          <Input
            label="Descripción"
            labelPlacement="outside"
            placeholder={item._note}
            variant="bordered"
            radius="sm"
            className="flex-[3]"
            value={item.note}
            onValueChange={v => onChange(v, 'note', index)}
          />

          <Button
            isIconOnly
            variant="light"
            title="Eliminar"
            onPress={() => remove(index)}
          >
            <IconX />
          </Button>
        </div>
      ))}

      <Render condition={isLoading && !data.length}>
        <div className="flex gap-4 animate-pulse mb-6">
          <div className="bg-gray/25 h-6 rounded-lg flex-1" />
          <div className="bg-gray/25 h-6 rounded-lg flex-1" />
          <div className="bg-gray/25 h-6 rounded-lg flex-[3]" />
        </div>
        <div className="flex gap-4 animate-pulse mb-6">
          <div className="bg-gray/25 h-6 rounded-lg flex-1" />
          <div className="bg-gray/25 h-6 rounded-lg flex-1" />
          <div className="bg-gray/25 h-6 rounded-lg flex-[3]" />
        </div>
        <div className="flex gap-4 animate-pulse mb-6">
          <div className="bg-gray/25 h-6 rounded-lg flex-1" />
          <div className="bg-gray/25 h-6 rounded-lg flex-1" />
          <div className="bg-gray/25 h-6 rounded-lg flex-[3]" />
        </div>
      </Render>

      <Render condition={!isLoading && !data.length}>
        <p className="text-center text-gray text-sm whitespace-pre">No hay datos para mostrar.{'\n'}Agregue uno para continuar.</p>
      </Render>

      <div className="flex justify-center mt-4">
        <Button
          isLoading={isLoading}
          isDisabled={isLoading}
          className="mt-4 bg-green text-white font-semibold"
          onPress={submit}
        >
          Guardar
        </Button>
      </div>
    </div>
  );
}

export default TabScale;
